<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1"> Advanced Search </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs6>
          <div class="caption">ชื่อพนักงาน</div>
          <input type="text" v-model="filter.staff_name" />
        </v-flex>
        <v-flex xs6 class="px-2">
          <div class="caption">แผนก</div>
          <div>
            <multiselect
              v-model="filter.department"
              :options="department_options"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              deselect-label
              :max-height="200"
              open-direction="bottom"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="caption">สังกัด</div>
          <div>
            <multiselect
              v-model="filter.affiliation"
              :options="affiliation_options"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              deselect-label
              :max-height="200"
              open-direction="bottom"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs6 class="px-2">
          <div class="caption">ระยะเวลา</div>
          <div>
            <multiselect
              v-model="filter.sop"
              :options="['All', 30, 60, 90]"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              deselect-label
              :max-height="200"
              open-direction="bottom"
            ></multiselect>
          </div>
        </v-flex>
        <v-flex xs6 class="pt-2">
          <div class="caption">Status</div>
          <div>
            <multiselect
              v-model="filter.sop_status"
              :options="['All', 'Pass', 'Fail']"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              deselect-label
              :max-height="150"
              open-direction="top"
            ></multiselect>
          </div>
        </v-flex>

        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn @click="clearSearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onSearch" color="primary">Search</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import hopinnHrApi from '@/api/hopinn-hr'
export default {
  components: {
    Multiselect
  },
  async mounted() {
    this.$store.dispatch('loading')
    await this.handleGetAffiliationOptions()
    await this.handleGetDepartmentOptions()
    this.$store.dispatch('loading')
  },
  data() {
    return {
      filter: {
        staff_name: '',
        affiliation: 'All',
        department: 'All',
        sop: 'All',
        sop_status: 'All'
      },
      department_options: [],
      affiliation_options: [],
      status_options: ['Hiring', 'Resign'],
      probation_level_options: [],
      sopStatus_options: []
    }
  },
  methods: {
    clearSearch() {
      this.filter = {
        staff_name: '',
        affiliation: 'All',
        department: 'All',
        sop: 'All',
        sop_status: 'All'
      }
      this.$emit('clear')
    },

    async handleGetAffiliationOptions() {
      const vm = this
      const affiliationResponse = await hopinnHrApi.getAffiliation()
      const tempAffiliation = []
      tempAffiliation.push('All')
      affiliationResponse.data.data.forEach((item) => {
        tempAffiliation.push(item.engname)
      })
      if (tempAffiliation) vm.affiliation_options = tempAffiliation
    },
    async handleGetDepartmentOptions() {
      const vm = this
      const departmentResponse = await hopinnHrApi.getDepartment()
      const tempDepartmentOptions = []
      tempDepartmentOptions.push('All')
      departmentResponse.data.data.forEach((item) => {
        tempDepartmentOptions.push(item.engname)
      })
      if (tempDepartmentOptions) vm.department_options = tempDepartmentOptions
    },

    onSearch() {
      let tempFilter = {}
      let filter = this.filter
      Object.keys(filter).forEach(function (key) {
        if (filter[key] !== 'All') {
          Object.assign(tempFilter, { [key]: filter[key] })
        }
      })

      this.$emit('search', tempFilter)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/SearchSopReport.vue